@use '~/theme/theme' as *;

.iconBackground {
  @include border-radius('full');

  max-width: spacing(5);
  max-height: spacing(5);
  min-width: spacing(5);
  min-height: spacing(5);
  display: flex;
  align-items: center;
  justify-content: center;
}
